import {
  getLocalStorageMeasureCardLastAcknowledgedVersion,
  setLocalStorageMeasureCardLastAcknowledgedVersion,
} from "api/dropsLocalStorage";
import { ALWAYS_MUTED_STATES } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/useMeasureCardMuteHistory";
import { MeasureOverviewDataContext } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewDataContext";
import { useCallback, useContext, useEffect, useState } from "react";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";

export function useRecentlyUpdatedState(information: CombinedHistoryResponse) {
  const [lastAcknowledgedVersion, setLastAcknowledgedVersion] = useState(() =>
    getLocalStorageMeasureCardLastAcknowledgedVersion(information.uuid),
  );
  const { forceRefresh } = useContext(MeasureOverviewDataContext);
  const [localRefreshCount, setLocalRefreshCount] = useState(0);

  const recentlyUpdated =
    information.version > lastAcknowledgedVersion &&
    !ALWAYS_MUTED_STATES.has(information.state);

  const acknowledgeLatestVersion = useCallback(() => {
    setLastAcknowledgedVersion(information.version);
    setLocalStorageMeasureCardLastAcknowledgedVersion(
      information.uuid,
      information.version,
    );
  }, [information]);

  if (
    lastAcknowledgedVersion === 0 &&
    information.version &&
    !information.references.some((r) => r.type === "REPLACED_EVENT_REF")
  ) {
    // Information is the first version of a new event; automatically mark it seen
    setLocalStorageMeasureCardLastAcknowledgedVersion(information.uuid, 1);
    setLastAcknowledgedVersion(1);
    setLocalRefreshCount((a) => a + 1);
  }

  useEffect(() => {
    // Must be done in an effect because forceRefresh() changes state in the context component
    // so React throws a "Cannot update a component (`A`) while rendering a different component (`B`)."
    // error otherwise
    if (localRefreshCount > 0) forceRefresh();
  }, [localRefreshCount]);

  return { lastAcknowledgedVersion, acknowledgeLatestVersion, recentlyUpdated };
}
